import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import AdminPage from './pages/AdminPage';
import AdminDashboard from './pages/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  // Einfacher Zustand für den Anmeldestatus direkt in App.jsx
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Funktion zum Überprüfen des Passworts
  const handleLogin = (password) => {
    if (password === 'monkey') {
      setIsAuthenticated(true);
      return true;
    }
    return false;
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        
        {/* AdminPage erhält die Login-Funktion als Prop */}
        <Route 
          path="/admin" 
          element={<AdminPage onLogin={handleLogin} />} 
        />
        
        {/* ProtectedRoute erhält den Status als Prop */}
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <AdminDashboard />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </Router>
  );
}

export default App;